/* eslint-env browser */
import * as React from 'react'
import PropTypes from 'prop-types'

function leadingZeros(num, length = null) {
  let length_ = length
  let num_ = num
  if (length_ === null) {
    length_ = 2
  }
  num_ = String(num_)
  while (num_.length < length_) {
    num_ = `0${num_}`
  }
  return num_
}

class CountDown extends React.Component {
  constructor() {
    super()
    this.state = {
      days: 0,
      hours: 0,
      min: 0,
      sec: 0,
    }
  }

  componentWillMount() {
    const date = this.getDateData(this.props.date)
    if (date) {
      this.setState(date)
    }
  }
  componentDidMount() {
    this.interval = setInterval(() => {
      const date = this.getDateData(this.props.date)
      if (date) {
        this.setState(date)
      } else {
        this.stop()
      }
    }, 1000)
  }
  componentWillUnmount() {
    this.stop()
  }

  getDateData() {
    const endDate = this.props.date

    let diff = (Date.parse(new Date(endDate)) - Date.parse(new Date())) / 1000

    if (diff <= 0) {
      return false
    }

    const timeLeft = {
      years: 0,
      days: 0,
      hours: 0,
      min: 0,
      sec: 0,
      millisec: 0,
    }

    if (diff >= 365.25 * 86400) {
      timeLeft.years = Math.floor(diff / (365.25 * 86400))
      diff -= timeLeft.years * 365.25 * 86400
    }
    if (diff >= 86400) {
      timeLeft.days = Math.floor(diff / 86400)
      diff -= timeLeft.days * 86400
    }
    if (diff >= 3600) {
      timeLeft.hours = Math.floor(diff / 3600)
      diff -= timeLeft.hours * 3600
    }
    if (diff >= 60) {
      timeLeft.min = Math.floor(diff / 60)
      diff -= timeLeft.min * 60
    }
    timeLeft.sec = diff
    return timeLeft
  }

  stop() {
    clearInterval(this.interval)
  }

  render() {
    const countDown = this.state
    let days
    if (countDown.days === 1) {
      days = this.props.days.singular
    } else {
      days = this.props.days.plural
    }
    return (
      <div className={this.props.className}>
        {countDown.days > 0 && (
          <span className={`${this.props.className}-col is-day`}>
            <strong>{leadingZeros(countDown.days)}</strong>
            <span>{days}</span>
          </span>
        )}
        {countDown.hours > 0 && (
          <span className={`${this.props.className}-col is-hour`}>
            <strong>{leadingZeros(countDown.hours)}</strong>
            <span>{this.props.hours}</span>
          </span>
        )}
        <span className={`${this.props.className}-col is-min`}>
          <strong>{leadingZeros(countDown.min)}</strong>
          <span>{this.props.mins}</span>
        </span>
        <span className={`${this.props.className}-col is-seg`}>
          <strong>{leadingZeros(countDown.sec)}</strong>
          <span>{this.props.segs}</span>
        </span>
      </div>
    )
  }
}

CountDown.propTypes = {
  date: PropTypes.object.isRequired,
  className: PropTypes.string,
  days: PropTypes.objectOf(PropTypes.string),
  hours: PropTypes.string,
  mins: PropTypes.string,
  segs: PropTypes.string,
}

CountDown.defaultProps = {
  date: new Date(),
  className: 'CountDown',
  days: {
    plural: ' Jours ',
    singular: ' Jour ',
  },
  hours: ' Heures ',
  mins: ' Minutes ',
  segs: ' Secondes ',
}

export default CountDown
